

define(function (require) {

    module.exports = function (win) {
        var doc = win.document,
            body = doc.body,
            E_float,
            E_floatMsg,
            E_floatContent,
            E_floatOk,
            E_floatCancel,
            initDom = false,
            flashTimeoutId,
            showTimeoutId,
            hideTimeoutId,
            E_mask;

        E_mask = doc.createElement('div');
        E_mask.className = 'c-float-mask hide';

        E_float = doc.createElement('div');
        E_float.className = 'c-float-popWrap msgMode hide';
        E_float.innerHTML = ['<style type="text/css">', '.c-float-modePop{text-align:center}.c-float-modePop .warnMsg{color:#fff}.c-float-modePop button{padding:0.1875rem 0.28125rem 0.1875rem 0.28125rem;color:#157afb;background:-webkit-gradient(linear,left top,left bottom,color-stop(0,#404040),color-stop(100%,#2e2e2e));border:none}.c-float-shade{width:100%;display:block;position:absolute;z-index:99;background-color:#000;opacity:.5;top:0;left:0}.c-float-mask{position:fixed;top:0;left:0;bottom:0;right:0;height:100%;width:100%;z-index:9998;background:rgba(0,0,0,.7);opacity:0;-webkit-transition:opacity .3s linear 0s}.c-float-shade.hide{display:none}.c-float-mask.hide{display:none}.c-float-popWrap{width:90%; border-radius:0.25rem;-webkit-border-radius:0.25rem;z-index:9999;position:fixed;overflow:hidden;left:50%;top:50%; margin-left: -45%; -webkit-transition:opacity .3s linear 0s}.c-float-popWrap .c-float-modePop{background-color:rgba(0,0,0,.7);-webkit-border-radius:0.25rem;border-radius:0.25rem;overflow:hidden;padding:0.3125rem;}.c-float-popWrap .c-float-modePop .warnMsg{padding:0;font-size:0.46875rem;line-height:0.5625rem;color:#fff;font-weight:400}.c-float-popWrap .c-float-modePop .content{line-height:1.5}.c-float-popWrap.hide{display:none;-webkit-box-shadow:none}.c-float-popWrap.show{display:block}.c-float-popWrap.msgMode .c-float-modePop .content,.c-float-popWrap.msgMode .c-float-modePop .doBtn{display:none}.c-float-popWrap.alertMode .c-float-modePop .content{display:none}.c-float-popWrap.alertMode .c-float-modePop .doBtn .cancel{display:none}.c-float-popWrap.alertMode,.c-float-popWrap.confirmMode{width:90%;}.c-float-popWrap.alertMode .c-float-modePop,.c-float-popWrap.confirmMode .c-float-modePop{background:#fff;padding:0;color:#202325}.c-float-popWrap.alertMode .c-float-modePop .content,.c-float-popWrap.confirmMode .c-float-modePop .content{padding:0.3125rem;border-bottom:0.03125rem solid #d6d9dc}.c-float-popWrap.alertMode .c-float-modePop .warnMsg,.c-float-popWrap.confirmMode .c-float-modePop .warnMsg{padding:0.3125rem;display:-webkit-box;-webkit-box-align:center;-webkit-box-pack:center;text-align:center;font-weight:700}.c-float-popWrap.alertMode .c-float-modePop .doBtn,.c-float-popWrap.alertMode .c-float-modePop .warnMsg,.c-float-popWrap.confirmMode .c-float-modePop .doBtn,.c-float-popWrap.confirmMode .c-float-modePop .warnMsg{border-bottom:0.03125rem solid #d6d9dc;color:#202325}.c-float-popWrap.alertMode .c-float-modePop .doBtn,.c-float-popWrap.confirmMode .c-float-modePop .doBtn{border-bottom:none;display:-webkit-box;-webkit-box-align:center}.c-float-popWrap.alertMode .c-float-modePop .content,.c-float-popWrap.confirmMode .c-float-modePop .content{display:block;color:#202325;padding:0.3125rem;line-height:0.75rem;font-size:0.46875rem;text-align:left;font-weight:700}.c-float-modePop button{-webkit-box-flex:1;color:#157afb;background:#fff;height:1.25rem;font-size:0.5625rem;display:block}.c-float-modePop button.cancel{border-right:0.03125rem solid #b2b2b2}.c-float-modePop button.ok{font-weight:700}', '</style>', '<div class="c-float-modePop">', '<div class="warnMsg"></div>', '<div class="content"></div>', '<div class="doBtn">', '<button class="cancel">取消</button>', '<button class="ok">确定</button>', '</div>', '</div>'].join('');

        E_floatMsg = E_float.querySelector('.warnMsg');
        E_floatContent = E_float.querySelector('.content');
        E_floatOk = E_float.querySelector('.doBtn .ok');
        E_floatCancel = E_float.querySelector('.doBtn .cancel');

        E_floatMsg.addEventListener('click', function () {
            // alert(E_float.className);
        }, false);

        function _extend(a, b) {
            for (var k in b) {
                a[k] = b[k];
            }
            return a;
        }

        function successHandler(e) {
            this.callback && this.callback(e, true);
        }

        function failureHandler(e) {
            this.callback && this.callback(e, false);
        }

        function ModePop(options) {
            this._options = _extend({
                mode: 'msg',
                text: '网页提示',
                useTap: false
            }, options || {});

            this._init();
        }

        _extend(ModePop.prototype, {
            _init: function _init() {
                var that = this,
                    opt = that._options,
                    mode = opt.mode,
                    text = opt.text,
                    okText = opt.okText,
                    cancelText = opt.cancelText,
                    content = opt.content,
                    callback = opt.callback,
                    background = opt.background,
                    clickEvent = opt.useTap ? 'touchend' : 'click';

                // set mode
                var classTxt = E_float.className;
                classTxt = classTxt.replace(/(msg|alert|confirm)Mode/i, mode + 'Mode');
                E_float.className = classTxt;

                // set background
                background && (E_float.style.background = background);

                // set text & content
                if (text) {
                    E_floatMsg.innerHTML = text;
                    E_floatMsg.style.display = 'block';
                } else {
                    E_floatMsg.style.display = 'none';
                }

                if (content) {
                    E_floatContent.innerHTML = content;
                    E_floatContent.style.display = 'block';
                } else {
                    E_floatContent.style.display = 'none';
                }

                E_floatOk.innerHTML = okText || '确定';
                E_floatCancel.innerHTML = cancelText || '取消';

                if (mode == 'alert' || mode == 'confirm') {
                    this.hasMask = true;
                } else {
                    this.hasMask = false;
                }

                // click event
                E_floatOk.removeEventListener('touchend', successHandler);
                E_floatOk.removeEventListener('click', successHandler);
                E_floatCancel.removeEventListener('touchend', successHandler);
                E_floatCancel.removeEventListener('click', successHandler);
                E_floatOk.addEventListener(clickEvent, successHandler, false);
                E_floatCancel.addEventListener(clickEvent, failureHandler, false);
                E_floatOk.callback = E_floatCancel.callback = function () {
                    callback.apply(that, arguments);
                };

                if (!initDom) {
                    initDom = true;
                    doc.body.appendChild(E_mask);
                    doc.body.appendChild(E_float);
                    win.addEventListener('resize', function () {
                        setTimeout(function () {
                            that._pos();
                        }, 500);
                    }, false);
                }
            },

            _pos: function _pos() {
                var rect = E_float.getBoundingClientRect(),
                    eW = rect.width,
                    eH = rect.height;

                E_float.style.marginLeft = -eW / 2 + 'px';
                E_float.style.marginTop = -eH / 2 + 'px';
            },

            isShow: function isShow() {
                return E_float.className.indexOf('show') > -1;
            },

            isHide: function isHide() {
                return E_float.className.indexOf('hide') > -1;
            },

            _cbShow: function _cbShow(pos) {
                var that = this,
                    opt = that._options,
                    onShow = opt.onShow;

                E_float.style.opacity = '1';
                that.hasMask && (E_mask.style.opacity = '1');
                that.hasMask && (E_mask.className = E_mask.className.replace(/hide/g, '').trim());

                if (!that.isShow()) {
                    E_float.className += ' show';
                    that.hasMask && (E_mask.className += ' show');
                }

                pos && that._pos();

                onShow && onShow.call(that);
            },

            show: function show() {
                var that = this;

                if (flashTimeoutId) {
                    clearTimeout(flashTimeoutId);
                    flashTimeoutId = null;
                    this._cbHide();
                }

                if (showTimeoutId) {
                    clearTimeout(showTimeoutId);
                    showTimeoutId = null;
                }

                if (hideTimeoutId) {
                    clearTimeout(hideTimeoutId);
                    hideTimeoutId = null;
                }

                if (!that.isShow()) {
                    E_float.className = E_float.className.replace(/hide/g, '').trim();
                    that.hasMask && (E_mask.className = E_mask.className.replace(/hide/g, '').trim());

                    that._pos();

                    setTimeout(function () {
                        E_float.style.opacity = '1';
                        that.hasMask && (E_mask.style.opacity = '1');
                    }, 1);

                    showTimeoutId = setTimeout(function () {
                        that._cbShow();
                    }, 300);
                } else {
                    that._cbShow(true);
                }
            },

            _cbHide: function _cbHide() {
                var that = this,
                    opt = that._options,
                    onHide = opt.onHide;

                E_float.style.opacity = '0';
                E_mask.style.opacity = '0';

                if (!that.isHide()) {
                    E_float.className = E_float.className.replace(/hide|show/g, '').trim();
                    E_float.className += ' hide';
                    E_mask.className = E_mask.className.replace(/hide|show/g, '').trim();
                    E_mask.className += ' hide';
                }
                onHide && onHide.call(that);
            },
            // ruoli 添加timeout参数，防止点击弹出框，立即再弹出一个框，出现闪动
            hide: function hide(timeout) {
                var that = this;

                if (showTimeoutId) {
                    clearTimeout(showTimeoutId);
                    showTimeoutId = null;
                }

                if (hideTimeoutId) {
                    clearTimeout(hideTimeoutId);
                    hideTimeoutId = null;
                }

                if (!that.isHide()) {
                    E_float.className = E_float.className.replace(/show/g, '').trim();
                    E_mask.className = E_mask.className.replace(/show/g, '').trim();

                    setTimeout(function () {
                        E_float.style.opacity = '0';
                        E_mask.style.opacity = '0';
                    }, 1);

                    hideTimeoutId = setTimeout(function () {
                        that._cbHide();
                    }, timeout || 300);
                } else {
                    that._cbHide();
                }
            },

            flash: function flash(timeout) {
                var that = this,
                    opt = that._options;

                that.show();

                //opt.onShow = function() {
                flashTimeoutId = setTimeout(function () {
                    if (flashTimeoutId) {
                        that.hide();
                    }
                }, timeout);
                //};
            }
        });

        var notification = new function () {

            this.simple = function (text, bg, timeout) {
                if (arguments.length == 2) {
                    if (typeof arguments[1] == 'number') {
                        timeout = arguments[1];
                        bg = undefined;
                    }
                }

                var pop = new ModePop({
                    mode: 'msg',
                    text: text,
                    background: bg
                });

                pop.flash(timeout || 2000);
                return pop;
            };

            this.msg = function (text, options) {
                return new ModePop(_extend({
                    mode: 'msg',
                    text: text
                }, options || {}));
            };

            this.alert = function (text, content, callback, options) {

                if (typeof content === 'function') {
                    options = callback;
                    callback = content;
                    content = null;
                }

                return new ModePop(_extend({
                    mode: 'alert',
                    text: text,
                    content: content,
                    callback: callback
                }, options || {}));
            };

            this.confirm = function (text, content, callback, options) {
                return new ModePop(_extend({
                    mode: 'confirm',
                    text: text,
                    content: content,
                    callback: callback
                }, options || {}));
            };

            this.pop = function (options) {
                return new ModePop(options);
            };
        }();

        return notification;
    }(window);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/c-notification/dist/index.js
// module id = 30
// module chunks = 0